<div class="premium-modal-wrapper">
  <!-- Header Premium Blended -->
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="dismiss()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">{{ current.id !== '0' ? 'Editar Estimado' : 'Nuevo Estimado' }}</div>
          <div class="title-sub">{{ current.tipo || 'Detalle Operativo' }}</div>
        </div>
        <div class="icon-btn" style="visibility: hidden;">
          <ion-icon name="close-outline"></ion-icon>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content class="light-bg" [scrollY]="true">
    <!-- Selector de Tipo Persistente (Sticky) -->
    <div class="sticky-tabs-container">
      <div class="glass-pill-container">
        <ion-segment [(ngModel)]="current.tipo" (ionChange)="onTipoChange()" mode="ios" [scrollable]="true"
          [disabled]="current.id !== '0'" class="premium-segment-pill">
          <ion-segment-button value="PLANILLA">
            <ion-icon name="people-outline"></ion-icon>
            <ion-label>Planilla</ion-label>
            <div class="segment-indicator-premium"></div>
          </ion-segment-button>
          <ion-segment-button value="MATERIAL">
            <ion-icon name="cube-outline"></ion-icon>
            <ion-label>Material</ion-label>
            <div class="segment-indicator-premium"></div>
          </ion-segment-button>
          <ion-segment-button value="MOVILIDAD">
            <ion-icon name="flashlight-outline"></ion-icon>
            <ion-label>Movilidad</ion-label>
            <div class="segment-indicator-premium"></div>
          </ion-segment-button>
          <ion-segment-button value="SUBCONTRATO">
            <ion-icon name="business-outline"></ion-icon>
            <ion-label>Subcontrato</ion-label>
            <div class="segment-indicator-premium"></div>
          </ion-segment-button>
          <ion-segment-button value="GENERAL">
            <ion-icon name="document-text-outline"></ion-icon>
            <ion-label>Nota</ion-label>
            <div class="segment-indicator-premium"></div>
          </ion-segment-button>
        </ion-segment>
      </div>
    </div>

    <div class="layout-wrapper">
      <div class="form-container-premium animate__animated animate__fadeInUp">

        <div class="content-sections">
          <!-- PLANILLA FIELDS -->
          <div *ngIf="current.tipo === 'PLANILLA'" class="section-card-premium">
            <div class="section-header">
              <ion-icon name="people-circle-outline"></ion-icon>
              <span>Personal Operativo</span>
            </div>

            <div class="premium-grid">
              <div class="premium-input-box">
                <label>Días</label>
                <div class="input-wrapper-inner">
                  <ion-input type="number" [(ngModel)]="current.dias" placeholder="0" mode="ios"></ion-input>
                </div>
              </div>
              <div class="premium-input-box">
                <label>Trabajadores</label>
                <div class="input-wrapper-inner">
                  <ion-input type="number" [(ngModel)]="current.trabajadores" placeholder="0" mode="ios"></ion-input>
                </div>
              </div>
            </div>

            <div class="premium-grid mt-16">
              <div class="premium-input-box">
                <label>Turno</label>
                <div class="input-wrapper-inner">
                  <ion-select [(ngModel)]="current.turno" (ionChange)="onTurnoChange()" interface="popover" mode="ios">
                    <ion-select-option value="DIURNO">Diurno</ion-select-option>
                    <ion-select-option value="NOCTURNO">Nocturno</ion-select-option>
                  </ion-select>
                </div>
              </div>
              <div class="premium-input-box">
                <label>Monto Diario ($)</label>
                <div class="input-wrapper-inner">
                  <ion-input type="number" [(ngModel)]="current.monto_diario" placeholder="0.00" mode="ios"></ion-input>
                </div>
              </div>
            </div>

            <!-- MOVILIDAD AUTOMATICA -->
            <div class="movilidad-panel-premium" *ngIf="current.id === '0'">
              <div class="mov-header">
                <div class="mov-title">
                  <ion-icon name="flashlight-outline"></ion-icon>
                  <div class="mov-info">
                    <span class="main">Gastos de Movilidad</span>
                    <span class="sub">Vincular combustible automáticamente</span>
                  </div>
                </div>
                <ion-toggle [(ngModel)]="addMovilidad" color="tertiary" mode="ios"></ion-toggle>
              </div>

              <div class="mov-body animate__animated animate__fadeIn" *ngIf="addMovilidad">
                <div class="premium-input-box no-bg">
                  <label>Combustible Diario ($)</label>
                  <div class="input-wrapper-inner border">
                    <ion-input type="number" [(ngModel)]="montoMovilidad" mode="ios"></ion-input>
                  </div>
                  <div class="mov-hint">
                    Total proyectado: <strong>{{ (current.dias || 0) * (montoMovilidad || 0) | currency }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- MATERIAL FIELDS -->
          <div *ngIf="current.tipo === 'MATERIAL'" class="section-card-premium">
            <div class="section-header">
              <ion-icon name="cube-outline"></ion-icon>
              <span>Insumos y Materiales</span>
            </div>
            <div class="premium-grid">
              <div class="premium-input-box">
                <label>Cantidad</label>
                <div class="input-wrapper-inner">
                  <ion-input type="number" [(ngModel)]="current.cantidad" placeholder="0.00" mode="ios"></ion-input>
                </div>
              </div>
              <div class="premium-input-box">
                <label>Costo Unitario ($)</label>
                <div class="input-wrapper-inner">
                  <ion-input type="number" [(ngModel)]="current.costo" placeholder="0.00" mode="ios"></ion-input>
                </div>
              </div>
            </div>
          </div>

          <!-- MOVILIDAD FIELDS -->
          <div *ngIf="current.tipo === 'MOVILIDAD'" class="section-card-premium">
            <div class="section-header">
              <ion-icon name="flashlight-outline"></ion-icon>
              <span>Logística y Traslados</span>
            </div>
            <div class="premium-grid">
              <div class="premium-input-box">
                <label>Días</label>
                <div class="input-wrapper-inner">
                  <ion-input type="number" [(ngModel)]="current.dias" placeholder="0" mode="ios"></ion-input>
                </div>
              </div>
              <div class="premium-input-box">
                <label>Monto Diario ($)</label>
                <div class="input-wrapper-inner">
                  <ion-input type="number" [(ngModel)]="current.monto_diario" placeholder="0.00" mode="ios"></ion-input>
                </div>
              </div>
            </div>
            <div class="total-pill-premium mt-16 purple-pill">
              <span class="label">TOTAL MOVILIDAD:</span>
              <span class="value">{{ (current.dias || 0) * (current.monto_diario || 0) | currency }}</span>
            </div>
          </div>

          <!-- SUBCONTRATO FIELDS -->
          <div *ngIf="current.tipo === 'SUBCONTRATO'" class="section-card-premium">
            <div class="section-header">
              <ion-icon name="business-outline"></ion-icon>
              <span>Gestión de Subcontratos</span>
            </div>

            <div class="premium-autocomplete">
              <label class="ac-label">Subcontratista <span class="req">*</span></label>
              <div class="ac-input-container">
                <ion-icon name="search-outline" class="search-icon"></ion-icon>
                <input class="ac-input-premium" type="text" [(ngModel)]="current.subcontratista"
                  (input)="filterSubcontratistas($event)" (focus)="filterSubcontratistas($event)"
                  (blur)="closeSubDropdown()" placeholder="Buscar o crear...">
                <ion-icon name="close-circle" class="ac-clear" *ngIf="current.subcontratista"
                  (click)="clearSubcontratista()"></ion-icon>
              </div>

              <div class="ac-dropdown-premium" *ngIf="showSubDropdown">
                <div class="ac-item" *ngFor="let s of filteredSubcontratistas" (click)="selectSubcontratista(s)">
                  <ion-icon name="person-circle-outline"></ion-icon>
                  <span class="name">{{ s.nombre }}</span>
                </div>
                <!-- Quick Create -->
                <div class="ac-item create-new" *ngIf="current.subcontratista && filteredSubcontratistas.length === 0"
                  (click)="createSubcontratista(current.subcontratista)">
                  <ion-icon name="add-circle"></ion-icon>
                  <span>Crear "<strong>{{current.subcontratista}}</strong>"</span>
                </div>
                <!-- Admin -->
                <div class="ac-item ac-admin" (click)="openAdminSubcontratistas()">
                  <ion-icon name="settings-outline"></ion-icon>
                  Configurar Lista
                </div>
              </div>

              <div class="status-chip-container mt-8" *ngIf="current.subcontratista && !showSubDropdown">
                <div class="status-chip" [class.verified]="isSubRegistrado">
                  <ion-icon [name]="isSubRegistrado ? 'checkmark-circle' : 'alert-circle'"></ion-icon>
                  <span>{{ isSubRegistrado ? 'Registrado' : 'Pendiente de Registro' }}</span>
                </div>
              </div>
            </div>

            <div class="premium-input-box mt-16">
              <label>Costo Total Acordado ($)</label>
              <div class="input-wrapper-inner">
                <ion-input type="number" [(ngModel)]="current.costo" placeholder="0.00" mode="ios"></ion-input>
              </div>
            </div>
          </div>

          <!-- COMENTARIO -->
          <div class="section-card-premium">
            <div class="section-header">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon>
              <span>Observaciones</span>
            </div>
            <div class="premium-textarea-box">
              <textarea [(ngModel)]="current.comentario" rows="4" placeholder="Escribe detalles relevantes aquí..."
                class="modern-textarea"></textarea>
            </div>
          </div>
        </div>

      </div>
      <div class="spacer-bottom"></div>
    </div>
  </ion-content>

  <!-- Footer Premium con Glassmorphism -->
  <div class="form-footer-actions">
    <!-- Delete Button -->
    <ion-button *ngIf="current.id !== '0'" (click)="delete()" [disabled]="loading" class="delete-btn" fill="clear">
      <div class="btn-content">
        <ion-icon name="trash-outline"></ion-icon>
        <span>ELIMINAR</span>
      </div>
    </ion-button>
    <!-- Save Button -->
    <ion-button (click)="save()" [disabled]="loading || (current.tipo === 'SUBCONTRATO' && !isSubRegistrado)"
      class="save-btn">
      <div class="btn-content">
        <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
        <span *ngIf="!loading">{{ current.id !== '0' ? 'ACTUALIZAR' : 'GUARDAR' }}</span>
        <ion-icon *ngIf="!loading" name="save-outline"></ion-icon>
      </div>
    </ion-button>
  </div>
</div>